import React from 'react';
import { cx } from '../../../../../ui/components/cx';

export interface SegmentedOption {
  value: string;
  label: React.ReactNode;
  disabled?: boolean;
}

interface SegmentedControlProps {
  options: SegmentedOption[];
  value: string;
  onChange: (value: string) => void;
  /** Accessible name for the group. */
  label: string;
  size?: 'sm' | 'md';
  className?: string;
}

/** Pill-shaped group of mutually exclusive buttons (view switchers, in-panel tabs). */
const SegmentedControl: React.FC<SegmentedControlProps> = ({ options, value, onChange, label, size = 'md', className }) => (
  <div className={cx('tp-segmented', size === 'sm' && 'tp-segmented--sm', className)} role="group" aria-label={label}>
    {options.map((o) => (
      <button
        key={o.value}
        type="button"
        className={cx('tp-segmented__item', o.value === value && 'tp-segmented__item--active')}
        aria-pressed={o.value === value}
        disabled={o.disabled}
        onClick={() => onChange(o.value)}
      >
        {o.label}
      </button>
    ))}
  </div>
);

export default SegmentedControl;
